<!-- Don't forget to use '.sync' with visible prop in parent component -->
<template>
  <v-dialog
    :value="visible"
    width="327px"
    max-width="500px"
    ref="dialog"
    @close="$emit('update:visible', false)"
    @click:outside="$emit('update:visible', false)"
  >
    <v-card ref="card">
      <v-card-title ref="title">Comments</v-card-title>
      <v-divider></v-divider>

      <div ref="comment-section" class="comment-section">
        <div v-for="(comment, index) in comments" :key="comment.id">
          <div class="comment">
            <div class="text-and-profile-wrapper">
              <profile-avatar
                :size="32"
                :username="comment.author.username"
                :preset-profile-pic="comment.author.profilePicture"
              ></profile-avatar>
              <p>
                <span class="username">{{ comment.author.username }} </span>
                <span>{{ comment.content }}</span>
              </p>
            </div>

            <div class="utilities">
              <span class="date">{{ relativeDateString(new Date(comment.timePosted).getTime()) }} </span>
              <comment-utility-button :size="19" :comment="comment" :review="review"></comment-utility-button>
            </div>
          </div>

          <v-divider v-if="index !== comments.length - 1"></v-divider>
        </div>
      </div>

      <v-divider></v-divider>
      <div ref="new-comment-section" class="new-comment-input">
        <textarea v-model="newComment" @input="autoExpandTextarea($event)" placeholder="Add a comment" />
        <button @click="postComment" :disabled="!newComment" class="post-button">post</button>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import profileAvatar from "./profile-avatar.vue";
import commentUtilityButton from "./comment-utility-button.vue";
import autoExpandTextarea from "../mixins/autoExpandTextarea";
import { formatV0Comment } from "../util/comments";
import { relativeDateString } from "../util/dateHelpers";

export default {
  name: "comments-popup.vue",

  props: {
    visible: Boolean,
    review: {},
    comments: Array,
  },

  emits: ["comment-posted"],

  components: { profileAvatar, commentUtilityButton },

  mixins: [autoExpandTextarea],

  computed: {
    commentsSectionElement() {
      return this.$refs["comment-section"];
    },
  },

  data: function () {
    return {
      newComment: "",
    };
  },

  mounted() {},

  methods: {
    relativeDateString,

    postComment() {
      this.$axios
        .post("/comment", {
          review_id: this.review.id,
          content: this.newComment,
        })
        .then((response) => {
          const comment = formatV0Comment(response.data);
          this.$emit("comment-posted", comment);
          this.newComment = "";

          // 1ms timeout used to wait for dom update
          setTimeout(() => {
            this.commentsSectionElement.lastChild.scrollIntoView({
              behavior: "smooth",
            });
          }, 1);
        });
    },
  },
};
</script>

<style scoped>
.v-dialog > .v-card > .v-card__title {
  padding: 10px 10px 6px;
  font-size: 24px;
  font-weight: bold;
  line-height: 1;
}

.comment-section {
  padding: 0 10px;
  overflow-y: auto;

  /* TODO: Scale max-height with the max-height of the card */
  max-height: 300px;
}

.comment {
  padding: 4px 0;
  line-height: normal;
}

.text-and-profile-wrapper {
  display: flex;
}

.text-and-profile-wrapper .profile-avatar {
  align-self: start;
  position: relative;
  top: 2px;
}
.text-and-profile-wrapper p {
  padding-left: 6px;
  flex-grow: 1;
  white-space: pre-wrap;
  margin-bottom: 0;
}

.text-and-profile-wrapper > p > .username {
  color: var(--v-text-primary);
  font-weight: 600;
}

.comment > .utilities {
  text-align: end;
  font-size: 12px;
}
.comment > .utilities > .date {
  color: var(--v-text-lighten1);
  font-weight: normal;
}

.new-comment-input {
  position: relative;
  display: flex;
  padding: 10px;
  color: var(--v-text-lighten1);
}

.new-comment-input > textarea {
  resize: none;

  height: 27px;
  /* 33px to space for "post" */
  padding: 4px 33px 4px 3px;

  font-size: 16px;
  line-height: normal;
  color: var(--v-text-base);

  outline: 1px solid var(--v-text-lighten2);
  border-radius: 3px;

  flex-grow: 1;
}

.new-comment-input > .post-button {
  height: 14px;
  padding: 0 2px;

  font-size: 12px;
  line-height: 1;
  color: rgba(var(--post-button-color-rgb), 0.8);

  position: absolute;
  right: 10px;

  /* Justify center */
  top: calc(50% - 2px);
  transform: translateY(-50%);
}
.new-comment-input > .post-button:hover {
  color: rgba(var(--post-button-color-rgb), 1);
}
.new-comment-input > .post-button:focus {
  outline: 1px solid rgb(var(--post-button-color-rgb));
}
.new-comment-input > .post-button:active {
  color: rgba(var(--post-button-color-rgb), 0.5);
}
.new-comment-input > .post-button:disabled {
  color: rgba(var(--post-button-color-rgb), 0.5);
}
</style>
